import React from 'react';
import { Box, SwipeableDrawer } from '@mui/material';
import './term-and-condition-modal.scss';

interface TermAndConditionModalProps {
  isVisible: boolean;
  handleClose: () => void;
  termNcondition: string;
}

export const TermAndConditionModal: React.FC<TermAndConditionModalProps> = ({
  isVisible,
  handleClose,
  termNcondition = '',
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={isVisible}
      onClose={handleClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        className: 'tnc-modal__drawer-paper',
      }}
    >
      <Box className="tnc-modal__container">
        <div className="tnc-modal__header">
          <div onClick={handleClose}>
            <span className={`tnc-modal__header-text  font-primary-semibold`}>
              {'Close'}
            </span>

            <span className="tnc-modal__header-title font-primary-semibold">
              {'Terms & Conditions'}
            </span>
          </div>
        </div>

        <div className="tnc-modal__divider" />

        <div className="tnc-modal__content">
          <div className="tnc-modal__tnc-data font-primary">
            {termNcondition}
          </div>
        </div>
      </Box>
    </SwipeableDrawer>
  );
};
